"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../core/table"));
var _linkButton = _interopRequireDefault(require("../../core/link-button"));
var _link = _interopRequireDefault(require("../../core/link"));
var _formatDateRange = _interopRequireDefault(require("../../../utils/formatDateRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const today = new Date().toISOString().split('T')[0];
var _ref = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-danger"
}, "Cancelled");
var _ref2 = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-danger"
}, "Not Published");
var _ref3 = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-muted"
}, "Finished");
var _ref4 = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-warning"
}, "Entries Closed");
var _ref5 = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-success"
}, "Open for Entry");
var _ref6 = /*#__PURE__*/_react.default.createElement("td", null);
var _ref7 = /*#__PURE__*/_react.default.createElement("td", null);
var _ref8 = /*#__PURE__*/_react.default.createElement("td", null);
class CompetitionTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      selectedDivisions: []
    });
    _defineProperty(this, "_isInPast", days => {
      if (!days || !days.length) return true;
      if (days[days.length - 1].dayDate < today) return true;
    });
    _defineProperty(this, "_competitionURL", comp => {
      return this.props.competitionBaseURL + comp.competitionSlug;
    });
    _defineProperty(this, "_getInfoText", comp => {
      const isInPast = this._isInPast(comp.competitionDays);
      if (comp.isCancelled) return _ref;
      if (!comp.isPublished) return _ref2;
      if (isInPast) return _ref3;
      if (comp.allClosedForEntryDate <= today) return _ref4;
      if (comp.openForOnlineEntryDate > today) {
        return /*#__PURE__*/_react.default.createElement("td", {
          className: "text-warning"
        }, 'Entries Open ' + (0, _occasion.default)(comp.openForOnlineEntryDate, 'ddd DD MMM'));
      }
      return _ref5;
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.competitions.map(comp => /*#__PURE__*/_react.default.createElement("tr", {
      key: comp.id
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: this._isInPast(comp.competitionDays) ? 'text-muted' : ''
    }, (0, _formatDateRange.default)(comp.competitionDays.map(d => d.dayDate))), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_link.default, {
      "data-test-id": 'competition-link-' + comp.competitionSlug,
      to: this._competitionURL(comp),
      className: this._isInPast(comp.competitionDays) ? 'text-muted' : ''
    }, comp.competitionName + (!comp.subTitle ? '' : ' - ' + comp.subTitle))), this._getInfoText(comp), /*#__PURE__*/_react.default.createElement("td", null, !comp.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      size: "sm",
      to: this._competitionURL(comp) + '/set-up'
    }, "Set Up")), !comp.isAdministratedByUser || !comp.isPublished ? _ref6 : /*#__PURE__*/_react.default.createElement("td", {
      key: "manage"
    }, /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      size: "sm",
      to: this._competitionURL(comp) + '/manage-entries'
    }, "Manage Entries")), !comp.isAdministratedByUser ? _ref7 : /*#__PURE__*/_react.default.createElement("td", {
      key: "finance"
    }, /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      size: "sm",
      to: this._competitionURL(comp) + '/finance'
    }, "Finance")), !(comp.isAdministratedByUser || comp.displayStartList || comp.startListNotes) ? _ref8 : /*#__PURE__*/_react.default.createElement("td", {
      key: "start-list"
    }, /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      size: "sm",
      to: this._competitionURL(comp) + '/start-list'
    }, "Start-List"))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = CompetitionTable;